import api from '../../config/APIConfig';

const { iAxios, apiUri } = api;

//const baseUrl = `http://testing.firmadox.cl/api/claveunica`;
const baseUrl = `${apiUri}/claveunica`;

export const ClaveUnicaActions = {
  login
  ,dataUser
}
function login() {
    return iAxios.get(`${baseUrl}`,{headers: {'sitePath': document.URL}})
}
function dataUser(token) {
  return iAxios.get(`${baseUrl}/datos?token=`+token)
}























/*const getAllTipoSolicitudByCAE = async (cae) => {

  try {
      const response = await iAxios.get(`${baseUrl}/GetAllTipoSolicitudByCAE/${cae}`);

      return response.data;
  } catch (error) {

      console.error("error: ", error);

      throw error;
  }
};

const getJornadaByTipoSolicitud = async (idTipoSolicitud) => {
  try {
      const response = await iAxios.get(`${baseUrl}/GetJornadaByTipoSolicitud/${idTipoSolicitud}`);

      return response.data;
  } catch (error) {

      console.error("error: ", error);

      throw error;
  }
};


const createSolicitud = async (params) => {

  try {
    const response = await iAxios.post(`${baseUrl}/CreateSolicitud`, params);

    return response;
  } catch (error) {

    console.error("error: ", error);

    throw error;
  }
};

const updateSolicitud = async (params) => {

  try {
    const response = await iAxios.put(`${baseUrl}/UpdateSolicitud`, params);

    return response;
  } catch (error) {

    console.error("error: ", error);

    throw error;
  }
};

export default {
  getAllTipoSolicitudByCAE,
  getJornadaByTipoSolicitud,
  login,
  createSolicitud,
  updateSolicitud
};
*/